export default __webpack_public_path__ + "static/1-5853ffa28509d4d2e6c6e606cdbb84f0.png";